import axios from "../api";
import { objectToParam } from "../../libs/utils";

export async function getRegistrationMaterialCategories(
  registrationId,
  params = {}
) {
  const parameters = objectToParam(params);
  const { data } = await axios.get(
    `/registrations/${registrationId}/material-categories?` + parameters
  );
  return data;
}

export async function getRegistrationMaterialCategory(registrationId, id) {
  const { data } = await axios.get(
    `/registrations/${registrationId}/material-categories/` + id
  );
  return data;
}

export async function createRegistrationMaterialCategory(
  registrationId,
  values
) {
  const { data } = await axios.post(
    `/registrations/${registrationId}/material-categories`,
    values
  );
  return data;
}

export async function deleteRegistrationMaterialCategory(registrationId, id) {
  const { data } = await axios.delete(
    `/registrations/${registrationId}/material-categories/` + id
  );
  return data;
}
